export default __webpack_public_path__ + "static/media/pulse-logo.27468c1d.svg";